import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 480,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    primary: {
      main: "#0F3460",
      light: "#3E5A85",
      dark: "#081C3A",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#E94560",
      light: "#F27588",
      dark: "#B0213F",
      contrastText: "#ffffff",
    },
    error: {
      main: "#D72638",
      light: "#F05463",
      dark: "#A31729",
      contrastText: "#ffffff",
    },
    success: {
      main: "#2ECC71",
      light: "#58D98B",
      dark: "#27AE60",
      contrastText: "#ffffff",
    },
    warning: {
      main: "#F39C12",
      light: "#F5B041",
      dark: "#B9770E",
      contrastText: "#ffffff",
    },
    info: {
      main: "#3498DB",
      light: "#5DADE2",
      dark: "#2C80B4",
      contrastText: "#ffffff",
    },
    background: {
      default: "#f3f7ff", // --background-color-1
      paper: "#ffffff", // --background-color-2
    },
    text: {
      primary: "#3d3d3d", // --text-1
      secondary: "#5c5b59",
      disabled: "#908c88",
    },
  },
  typography: {
    fontFamily: '"Poppins", sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
  },
});

export default theme;
